import React from "react"
import DocumentTitle from 'react-document-title';
import Icon from "@material-ui/core/Icon";
import Fab from "@material-ui/core/Fab";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from  "@material-ui/core/TableBody";
import Paper from  "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TextField from "@material-ui/core/TextField";
import Dialog from "material-ui/Dialog";
import  {performSecureRequest} from '../../utils/Connections';
import * as Connections from "../../utils/Connections.js";
import Button from '@material-ui/core/Button';






let background={
    color:"whitesmoke",
    backgroundImage:"url(http://khula.co.za/images/veggieback3.png)"
}

class inputMarket extends React.Component{

    constructor(props){
        super(props)

        this.state = {

            farmerId:"",
            viewRequest:false,
            amount:"",
            name:"",
            price:null,
            descriptions:"",
            category:"",
            allProducts:[],
            categories:[]

        }

        this.handleCancelDialog=this.handleCancelDialog.bind(this)
        this.fundFarmerRequest=this.fundFarmerRequest.bind(this)
        this.processSuccessSubmitProduct=this.processSuccessSubmitProduct.bind(this)
        this.processError=this.processError.bind(this)
        this.submitProduct=this.submitProduct.bind(this)
        this.handleOnChange=this.handleOnChange.bind(this)
        this.successGetInputProducts=this.successGetInputProducts.bind(this)
    }

    handleCancelDialog(dialogName){
        this.setState({
            [dialogName]:false,
            farmerId:null,
            amount:0
        })
    }
    processSuccessSubmitProduct(data){
        alert("Product added successfully")
        this.handleCancelDialog("viewRequest")
        this.componentDidMount()
    }
    processError(data){
        alert("error in submission" + data)
    }
    submitProduct(){
        let body={
            type:"upload_input_product",
            name:this.state.name,
            price:this.state.price,
            category:this.state.category,
            description:this.state.description
        }
        performSecureRequest(body,this.processSuccessSubmitProduct,this.processError)
    }

    componentDidMount() {
        var data = {
            "type": "get_input_products",
        }
        Connections.performSecureRequest(data, this.successGetInputProducts, this.processError)

    }

    successGetInputProducts(data) {
        this.setState({
            allProducts: data.inputs,
            categories:data.categories
        })
    }

    fundFarmerRequest(){
        this.setState({
            viewRequest:true
            // farmerProfile:farmer,
        })
    }

    handleOnChange = (e) => {
        this.setState({
            category: e.target.value
        })


    }


    render(){
        const addProductActions = [
            <button onClick={()=>
                this.handleCancelDialog('viewRequest')
            } className="uk-button uk-button-default " type="button">Cancel</button>,
            <button onClick={()=>this.submitProduct()} className="uk-button uk-button-primary" type="button">Add Product</button>
        ];
        return(
            <DocumentTitle title="Khula - Home">
                <div className="main-content">
            <div>
                <div className="row">
                    <div className="col col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                        <div className="homecard" style={{backgroundColor:"white", boxShadow:"2px 2px lightgrey"}}>
                            <h5>Add new product</h5>
                            <Fab onClick={()=>this.fundFarmerRequest()} style={{backgroundColor:"green", marginRight:"0.75rem"}} size="small" color="primary" aria-label="add">
                                <Icon>add_circle_outline</Icon>
                            </Fab>
                        </div>

                    </div>
                    <div className="col col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                        <div className="homecard" style={{backgroundColor:"transparent",boxShadow:"2px 2px 3px 3px transparent"}}>
                            <h5>welcome to input land</h5>
                            <hp>welcome to input land</hp>
                        </div>

                    </div>
                    <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="homecard" style={{backgroundColor:"white", boxShadow:"2px 2px 3px 3px lightgrey"}}>
                            <h5>Your products</h5>

                            <Paper>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">ID</TableCell>
                                            <TableCell align="left">Name</TableCell>
                                            <TableCell align="left">Description</TableCell>
                                            <TableCell align="left">Price</TableCell>
                                            <TableCell align="left">Category</TableCell>
                                            <TableCell align="left">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {this.state.allProducts.map((product)=>

                                            <TableRow>
                                                <TableCell>{product.id} </TableCell>
                                                <TableCell>{product.name} </TableCell>
                                                <TableCell>{product.description} </TableCell>
                                                <TableCell>R {product.price} </TableCell>
                                                <TableCell>{product.category}</TableCell>
                                                <TableCell>
                                                    <Fab style={{backgroundColor:"orange",marginRight:"0.75rem"}} size="small" color="primary" aria-label="add">
                                                        <Icon>
                                                            edit</Icon>
                                                    </Fab>
                                                    <Fab style={{backgroundColor:"red", marginRight:"0.75rem"}} size="small" color="primary" aria-label="add">
                                                        <Icon>
                                                            delete_outline</Icon>
                                                    </Fab>
                                                </TableCell>
                                            </TableRow>


                                        )}

                                    </TableBody>
                                </Table>
                            </Paper>

                        </div>
                    </div>
                </div>

            </div>

                    <Dialog
                        title={<h3 style={background} className="uk-modal-title">Add new input product </h3>}
                        modal={false}
                        open={this.state.viewRequest}
                        onRequestClose={() =>this.handleCancelDialog("viewRequest")}
                        actions={addProductActions}
                        autoScrollBodyContent={true}>
                        <div className="dialogcontainer">
                            <div className="inputdialog" style={{display:"flex", flexDirection:"row", flexWrap:"wrap"}}>


                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={{marginTop:"1rem"}}>
                                    <Button variant="outlined" color="primary" style={{fontSize:"16px"}}>Upload Image | <Icon className="fa-upload">cloud_upload</Icon></Button>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" style={{marginTop:"1rem"}}>

                                <TextField

                                    style={{padding:"0.15rem", width:"100%"}}
                                    id="outlined-adornment-amount"
                                    variant="outlined"
                                    label="Name"
                                    value={this.state.name}
                                    onChange={(e) => this.setState({
                                        name:e.target.value
                                    })}
                                />
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" style={{marginTop:"1rem"}}>
                                <TextField

                                    style={{padding:"0.15rem", width:"100%"}}
                                    id="outlined-adornment-amount"
                                    variant="outlined"
                                    label="Price"
                                    value={this.state.price}
                                    onChange={(e) => this.setState({
                                        price:e.target.value
                                    })}
                                />
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" style={{marginTop:"1rem", paddingTop:"1rem"}}>


                                    <select
                                        defaultValue="fertilizer"
                                             onChange={this.handleOnChange}
                                        style={{backgroundColor:"white"}}
                                    >
                                        {
                                            this.state.categories.map((category,i)=>{
                                                return <option key={category}>{category.name}</option>
                                            })
                                        }

                                        {/*<option value="fertilizer">Choose Category</option>*/}
                                        {/*<option value="fertilizer">fertilizer</option>*/}
                                        {/*<option value="machinery">machinery</option>*/}
                                        {/*<option value="seeds">seeds</option>*/}
                                    </select>
                                </div>




                                <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={{marginTop:"1rem"}}>
                                <TextField

                                    style={{padding:"0.15rem", width:"100%"}}
                                    id="outlined-multiline-flexible"
                                    multiline
                                    rows="4"
                                    rowsMax="4"
                                    variant="outlined"
                                    label="Description"
                                    value={this.state.description}
                                    helperText="Add description"
                                    onChange={(e) => this.setState({
                                        description:e.target.value
                                    })}
                                />
                                </div>

                            </div>
                        </div>
                    </Dialog>



                </div>



            </DocumentTitle>
        )

    }


}

export default inputMarket;


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/inputmarket.js